import React from 'react';
import CombinedCalculatorApp from './CombinedCalculatorApp';

function App() {
  return (
    <div className="App">
      <CombinedCalculatorApp />
    </div>
  );
}

export default App;
